import { render, staticRenderFns } from "./HollowDotsSpinner.vue?vue&type=template&id=66780388&scoped=true"
import script from "./HollowDotsSpinner.vue?vue&type=script&lang=js"
export * from "./HollowDotsSpinner.vue?vue&type=script&lang=js"
import style0 from "./HollowDotsSpinner.vue?vue&type=style&index=0&id=66780388&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66780388",
  null
  
)

export default component.exports